import http from "../../http";

const BASE = "/gateway/api/sycompany/pc/companySupply";

/** 供应链供给 PC */
const companySupply = {
  storePointMatrix(r) {
    return http.get(`${BASE}/stats/storePointMatrix`, r);
  },
  agentSupplierPage(r) {
    return http.get(`${BASE}/agentSupplier/page`, r);
  },
  agentSupplierList(r) {
    return http.get(`${BASE}/agentSupplier/list`, r);
  },
  agentSupplierEnable(r) {
    return http.payload(`${BASE}/agentSupplier/enable`, r);
  },
  agentSupplierDisable(r) {
    return http.payload(`${BASE}/agentSupplier/disable`, r);
  },
  agentSupplierGoodsPage(r) {
    return http.get(`${BASE}/agentSupplier/goodsPage`, r);
  },
  agentSupplierStoreBindPage(r) {
    return http.get(`${BASE}/agentSupplier/storeBindPage`, r);
  },
  agentSupplierProfitPointGet(r) {
    return http.get(`${BASE}/agentSupplier/profitPoint/get`, r);
  },
  agentSupplierProfitPointSave(r) {
    return http.payload(`${BASE}/agentSupplier/profitPoint/save`, r);
  },
  agentSupplierProfitPointLogPage(r) {
    return http.get(`${BASE}/agentSupplier/profitPoint/logPage`, r);
  },
  agentSupplierProfitPointListBySupplier(r) {
    return http.get(`${BASE}/agentSupplier/profitPoint/listBySupplier`, r);
  },
  agentSupplierGoodsBindProfitPoint(r) {
    return http.payload(`${BASE}/agentSupplier/goods/bindProfitPoint`, r);
  },
  agentsBySupplier(r) {
    return http.get(`${BASE}/agentSupplier/agentsBySupplier`, r);
  },
  agentStoreOptions(r) {
    return http.get(`${BASE}/agentStore/options`, r);
  },
  agentStoreListWithSuppliers(r) {
    return http.get(`${BASE}/agentStore/listWithSuppliers`, r);
  },
  storeBindPage(r) {
    return http.get(`${BASE}/storeBind/page`, r);
  },
  storeBindList(r) {
    return http.get(`${BASE}/storeBind/list`, r);
  },
  storeBindEnable(r) {
    return http.payload(`${BASE}/storeBind/enable`, r);
  },
  storeBindCreateBStore(r) {
    return http.payload(`${BASE}/storeBind/createBStore`, r);
  },
  storeBindBindBByCompanyCode(r) {
    return http.payload(`${BASE}/storeBind/bindBByCompanyCode`, r);
  },
  storeBindLookupByCompanyCode(r) {
    return http.get(`${BASE}/storeBind/lookupByCompanyCode`, r);
  },
  storeBindDisable(r) {
    return http.payload(`${BASE}/storeBind/disable`, r);
  },
  storeBindCandidateStores(r) {
    return http.get(`${BASE}/storeBind/candidateStores`, r);
  },
};

export default companySupply;
